import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { WhatCategoryRatingModuleName } from '@/store/modules/modules'

export class WhatCategoryRatingViewModel {
  private store = useStore()

  chartData: ComputedRef<{ labelChartData: string[][]; categoryRatingChartData: number[][]; maxRating: number }> =
    computed(() => this.store.getters[`${WhatCategoryRatingModuleName}/chartData`])
  chartSeries: ComputedRef<any[]> = computed(() => this.store.getters[`${WhatCategoryRatingModuleName}/chartSeries`])
  chartOptions: ComputedRef<any> = computed(() => this.store.getters[`${WhatCategoryRatingModuleName}/chartOptions`])
  hasData: ComputedRef<boolean> = computed(() => this.store.getters[`${WhatCategoryRatingModuleName}/hasData`])

  setChartData(chartData: {
    labelChartData: string[][]
    categoryRatingChartData: number[][]
    maxRating: number
  }): void {
    this.store.commit(`${WhatCategoryRatingModuleName}/setChartData`, chartData)
  }

  setChartSeries(chartSeries: any[]): void {
    this.store.commit(`${WhatCategoryRatingModuleName}/setChartSeries`, chartSeries)
  }

  setChartOptions(chartOptions: any): void {
    this.store.commit(`${WhatCategoryRatingModuleName}/setChartOptions`, chartOptions)
  }

  setHasData(hasData: boolean): void {
    this.store.commit(`${WhatCategoryRatingModuleName}/setHasData`, hasData)
  }
}
